import { allRequestsNotStarted } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
var IReducerKeys = /* @__PURE__ */ ((IReducerKeys2) => {
  IReducerKeys2["experimentationGroups"] = "groups";
  return IReducerKeys2;
})(IReducerKeys || {});
const defaultReducerState = {
  [
    "groups"
    /* experimentationGroups */
  ]: {}
};
const prefix = `EXPERIMENTATION_GROUPS`;
const loadArgs = {
  actionPrefix: `${prefix}/SELECT`,
  reduxKeyNested: ({ workspaceId }) => ["groups", workspaceId],
  loadResource: (payload) => MdsDataplaneResources.getExperimentationGroups(payload.workspaceId),
  onCompleteSuccess: (result) => {
    return result;
  },
  dontLoad: ({ workspaceId }, state) => {
    var _a;
    return !allRequestsNotStarted((_a = state == null ? void 0 : state.experimentation_groups["groups"][workspaceId]) == null ? void 0 : _a.status);
  }
};
const loadEpicReducer = loadResourcesUtils(loadArgs);
const reducer = (state = defaultReducerState, action) => {
  state = loadEpicReducer.reduxChange(state, action);
  return state;
};
const selectExperimentationGroupsReducersMapObject = {
  experimentation_groups: reducer
};
export {
  IReducerKeys,
  selectExperimentationGroupsReducersMapObject as default,
  defaultReducerState,
  loadEpicReducer,
  reducer,
  selectExperimentationGroupsReducersMapObject
};
//# sourceMappingURL=LoadExperimentationGroups.ducks.js.map
